import { Component } from '@angular/core';

@Component({
  selector: 'app-term-use',
  templateUrl: './term-use.component.html'
})
export class TermUseComponent {

}
